/*
  Field Ethos — membership add-to-cart.
  Any element with [data-fe-join] adds the membership subscription straight to the cart
  (variant + selling plan come from data attributes). Once the membership is in the cart,
  every join button switches to its "added" label and the next click goes to checkout.
*/
(function () {
  if (window.FEMembership) return;

  var state = { inCart: false, busy: false };

  function buttons() {
    return document.querySelectorAll('[data-fe-join]');
  }

  function render() {
    buttons().forEach(function (btn) {
      var label = btn.querySelector('[data-fe-join-label]') || btn;
      label.textContent = state.inCart ? btn.dataset.labelAdded : btn.dataset.labelDefault;
      btn.setAttribute('aria-busy', state.busy ? 'true' : 'false');
    });
  }

  function updateCartBubbles(sections) {
    if (!sections) return;
    ['cart-icon-bubble', 'mobile-cart-icon-bubble'].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el || !sections[id]) return;
      var parsed = new DOMParser().parseFromString(sections[id], 'text/html').querySelector('.shopify-section');
      if (parsed) el.innerHTML = parsed.innerHTML;
    });
  }

  function add(btn) {
    var variantId = parseInt(btn.dataset.variantId, 10);
    if (!variantId) return;

    var item = { id: variantId, quantity: 1 };
    if (btn.dataset.sellingPlan) item.selling_plan = parseInt(btn.dataset.sellingPlan, 10);

    var miniCart = window.shopSettings && window.shopSettings.cartDrawer ? document.querySelector('mini-cart') : null;
    var sections = miniCart ? miniCart.getSectionsToRender().map(function (s) { return s.id; }) : ['cart-icon-bubble', 'mobile-cart-icon-bubble'];

    state.busy = true;
    render();

    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [item], sections: sections, sections_url: window.location.pathname })
    })
      .then(function (res) { return res.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message);
        state.inCart = true;
        if (miniCart) {
          miniCart.renderContents(res);
        } else {
          updateCartBubbles(res.sections);
        }
        document.dispatchEvent(new CustomEvent('fe:membership-added', { detail: res }));
      })
      .catch(function (err) {
        console.error('[FE membership] add to cart failed:', err);
        // Fall back to the product page so the customer can still join.
        if (btn.dataset.fallbackUrl) window.location.href = btn.dataset.fallbackUrl;
      })
      .finally(function () {
        state.busy = false;
        render();
      });
  }

  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest('[data-fe-join]');
    if (!btn) return;
    evt.preventDefault();
    if (state.busy) return;
    if (state.inCart || btn.dataset.inCart === 'true') {
      window.location.href = '/checkout';
      return;
    }
    add(btn);
  });

  window.FEMembership = { render: render };
})();
